import { parseDate } from './utils'
import { AppointmentStatus } from '../utils/enums'

const disabilityRates = {
	ITA: 100,
	SI: 0,
}

export default class AppointmentConnectionDisability {
	static fromJSON(json) {
		return new AppointmentConnectionDisability(
			json.expertiseIds,
			json.appointments
		)
			.withTableData()
			.withDiagramData(json.paths)
	}

	constructor(expertiseIds, appointments) {
		this.expertiseIds = expertiseIds
		this.appointments = appointments
	}

	withTableData() {
		this.tableData = (this.appointments ?? []).map(
			({
				id,
				expertise,
				expertiseId,
				disabilityId,
				disabilityRate,
				permanentDisabilityRate,
				idNextAppointment,
				date,
				state,
				stateId,
			}) => ({
				Id: id,
				IdNextAppointment: idNextAppointment,
				Date: parseDate(date).shortDateFormat,
				Specialty: `[${expertiseId}] ${expertise}`,
				Disability: `${disabilityId ?? 'N/D'} - ${
					disabilityRates[disabilityId] ??
					disabilityRate ??
					permanentDisabilityRate ??
					0
				}%`,
				State: state,
				StateId: stateId,
			})
		)

		return this
	}

	withDiagramData(paths) {
		const allPointsMapper = (this.appointments ?? []).reduce(
			(result, appointment, index) => {
				result[appointment.id] = {
					x: this.expertiseIds.findIndex(
						(expId) => expId === appointment.expertiseId
					),
					y: index,
					stateId: appointment.stateId,
				}
				return result
			},
			{}
		)

		const excludedStates = new Set([
			AppointmentStatus.MissedPatient,
			AppointmentStatus.MissedDoctor,
			AppointmentStatus.Nullified,
			AppointmentStatus.Rescheduled,
		])

		const visiblePaths = (paths ?? []).filter((path) =>
			path.some(
				(appointment) =>
					!excludedStates.has(
						allPointsMapper[appointment.id]?.stateId
					)
			)
		)

		const visibleIds = new Set(
			visiblePaths.flatMap((path) => path.map((a) => String(a.id)))
		)

		const pointsMapper = (this.appointments ?? [])
			.filter((a) => visibleIds.has(String(a.id)))
			.reduce((result, appointment, index) => {
				result[appointment.id] = {
					x: this.expertiseIds.findIndex(
						(expId) => expId === appointment.expertiseId
					),
					y: index,
					stateId: appointment.stateId,
				}
				return result
			}, {})

		const expertiseIds = this.expertiseIds ?? []
		const pathColumns = [...expertiseIds].sort((a, b) => a - b)

		this.allTableData = this.tableData ?? []
		this.allPaths = paths ?? []
		this.allPointsMapper = allPointsMapper

		this.tableData = this.allTableData.filter(
			(row) =>
				visibleIds.has(String(row.Id)) ||
				!excludedStates.has(allPointsMapper[row.Id]?.stateId)
		)
		this.paths = visiblePaths
		this.pointsMapper = pointsMapper
		this.pathColumns = pathColumns

		return this
	}
}
